import LottieView from '$tablet-app/src/app/components/LottieView';

export const GeneratingMealPlanAnimation = () => {
  return (
    <LottieView autoPlay loop source={require('../../assets/Cooking.json')} />
  );
};
